"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  fillOpacity: ".3",
  d: "M12 12h8.99L24 8.98C20.93 5.9 16.69 4 12 4S3.07 5.9 0 8.98l6.35 6.36C7.79 13.89 9.79 13 12 13z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 21v-8c-2.21 0-4.2.89-5.65 2.34zm9-5.59L19.59 14l-2.09 2.09L15.41 14 14 15.41l2.09 2.09L14 19.59 15.41 21l2.09-2.08L19.59 21 21 19.59l-2.08-2.09z"
}, "1")], 'SignalWifiConnectedNoInternet1TwoTone');